"use client";
import {
  useCompositeStoreProps
} from "./7GBW5FLS.js";
import {
  usePopoverStoreProps
} from "./XWCFCD3Q.js";
import {
  useStore,
  useStoreProps
} from "./EKQEJRUF.js";

// src/combobox/combobox-store.ts
import * as Core from "@ariakit/core/combobox/combobox-store";
function useComboboxStoreProps(store, update, props) {
  useStoreProps(store, props, "value", "setValue");
  useStoreProps(store, props, "selectedValue", "setSelectedValue");
  useStoreProps(store, props, "resetValueOnHide");
  useStoreProps(store, props, "resetValueOnSelect");
  return useCompositeStoreProps(
    usePopoverStoreProps(store, update, props),
    update,
    props
  );
}
function useComboboxStore(props = {}) {
  const [store, update] = useStore(Core.createComboboxStore, props);
  return useComboboxStoreProps(store, update, props);
}

export {
  useComboboxStoreProps,
  useComboboxStore
};
